Controller = App.loadClass 'core::Angular/Controller'

class exports.EventsController extends Controller
    constructor: (
        @scope
        @transitions
        @modal
        @http
        @service
        @state
        _1
        _2
        _3
        @ngModal
    ) ->
        super

        @service.onDataLoaded @scope, () =>
            for type, events of @service.fpcResult.events
                if events.length > @service.fpcResult.data[type]
                    @service.fpcResult.data[type] = events.length

    addForm: (formType) =>
        @service.save @service.fpcResult.id
        .then () =>
            {
                fertilizer: () => @ngModal.openFertilizerForm(@service.field, @service.year, null),
                cover_crop: () => @ngModal.openCoverCropForm(@service.field, @service.year, null),
                spraying: () => @ngModal.openSprayingForm(@service.field, @service.year, null),
                planting: () => @ngModal.openPlantingForm(@service.field, @service.year, null, @service.mfCrop, null, true),
            }[formType]()
                .modalRef.result.then () =>
                    @service.loadFieldprint @service.fpcResult.id
                .catch _.noop

    editForm: (formType) =>
        @service.save @service.fpcResult.id
        .then () =>
            @editFormHelper formType

    editFormHelper: (formType, events = null) =>
        events ?= _.uniq @service.fpcResult.events[formType]
        afterForm = () =>
            if events.length > 0
                @editFormHelper formType, events
            else
                @service.loadFieldprint @service.fpcResult.id

        # Map the form type to a function, and launch that dialog
        {
            fertilizer: () => @ngModal.openFertilizerForm(@service.field, @service.year, { layers_id: events.pop(), mode: 'Edit' }),
            cover_crop: () => @ngModal.openCoverCropForm(@service.field, @service.year, { layers_id: events.pop(), mode: 'Edit' }),
            spraying: () => @ngModal.openSprayingForm(@service.field, @service.year, { layers_id: events.pop(), mode: 'Edit' }),
            planting: () => @ngModal.openPlantingForm(@service.field, @service.year, { layers_id: events.pop(), mode: 'Edit' }),
        }[formType]()
            .modalRef
            .result
            .then afterForm
            .catch afterForm

    incrementEvents: (inputName) =>
        @service.fpcResult.data[inputName]++

    decrementEvents: (inputName) =>
        @service.fpcResult.data[inputName]--

    eventsInputDisabled: (inputName) =>
        if not @service.fpcResult?.events? or not @service.fpcResult.events[inputName]?
            return true

        # Cannot have fewer events than you have recorded
        if @service.fpcResult.events[inputName].length is @service.fpcResult.data[inputName]
            return true


        minimumEvents = @service.config[@service.crop].steps.value['Production Practices'].value.events.value[inputName].value.minimum?.value or 0
        return @service.fpcResult.data[inputName] <= minimumEvents

    eventStatus: (inputName) =>
        if not @service.fpcResult.events?
            return ''

        eventsIntended = @service.fpcResult.data[inputName]
        eventsRecorded = @service.fpcResult.events[inputName]?.length

        if eventsIntended > eventsRecorded and eventsRecorded is 0
            return 'Unstarted'

        if eventsIntended > eventsRecorded and eventsRecorded > 0
            return 'In Process'

        if eventsIntended is eventsRecorded
            return 'Done'

        # Theoretically this should never happen, but this logic follows the SRS exactly
        return ''

    numberOfEvents: (formType) =>
        _.uniq(@service.fpcResult.events[formType]).length
